
import React, { useState, useRef } from 'react'

import classNames from 'classnames'

import styles from './process_accordion.module.sass'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'
import Image from './basic/image'

function ProcessAccordion(props) {
	const accordionRef = useRef(null)
	const fields = props.fields
	const accordionItems = fields.items.map(item => { return {...item} })
	const [state, setState] = useState({items: accordionItems})
	const refreshHeight = useRef(null)

	const handleItemClick = (el, index) => {
		if (typeof window !== 'undefined' && window.innerWidth < 768) {
			el.preventDefault()

			const accordionItems = state.items
			const accordionContent = el.currentTarget.querySelector(`.${styles.body}`)
			const accordionContentInner = el.currentTarget.querySelector(`.${styles.content}`)

			if (refreshHeight.current) {
				clearTimeout(refreshHeight.current)
			}

			if (accordionItems[index].active){
				accordionItems[index].active = false
				accordionContent.style.height = '0px'
			} else {
				accordionItems[index].active = true
				accordionContent.style.height = accordionContentInner.scrollHeight + 'px'

				//double-check height after content loads
				refreshHeight.current = window.setTimeout(() => {
					accordionContent.style.height = accordionContentInner.scrollHeight + 'px'
				}, 750)
			}

			setState({items: accordionItems})
		}
	}
	
	return <div ref={accordionRef} className={classNames(styles.process_accordion, styles[`columns_${state.items.length}`])}>
		<BlockWrapper {...props} fullbleed={props.accordionContent ? false : true}>
			<div className={classNames(styles.accordion_wrapper)}>
				<ScrollAnimation styles={styles}>
					{state.items.map((item, i) => {
						return <div className={classNames(styles.item, item.active == true ? styles.active : '')} onClick={(e) => handleItemClick(e, i)} key={i}>
							<div className={styles.item_wrapper}>
								<div className={classNames(styles.title)}>
									<p className={styles.step}>{item.step}</p>
									<h3>{item.title}</h3>
								</div>
								<div className={classNames(styles.body)}>
									{item.icon && <Image {...item.icon} className={styles.icon}/>}
									<div className={classNames(styles.content)} dangerouslySetInnerHTML={{ __html: item.content}} />
								</div>
							</div>
						</div>
					})}
				</ScrollAnimation>
			</div>
		</BlockWrapper>
	</div>
}

export default ProcessAccordion